// removed by extract-text-webpack-plugin
module.exports = {"Blackberry":"#333D47","frame":"G7e6a6d Ge12a44","row":"Gafe1b6","addressContainer":"Gef92b1","hide":"G2c45d7"};